export default __webpack_public_path__ + "static/media/intermares_logo.ddeab9ed.png";